import {
  FETCH_LATEST_BO_REQUEST,
  FETCH_LATEST_BO_SUCCESS,
  FETCH_LATEST_BO_FAILURE,
  FETCH_BO_BY_ID_REQUEST,
  FETCH_BO_BY_ID_SUCCESS,
  FETCH_BO_BY_ID_FAILURE,
  SEARCH_BO_REQUEST,
  SEARCH_BO_SUCCESS,
  SEARCH_BO_FAILURE,
  GET_DATA_UPDATE_ANALYSIS_REQUEST,
  GET_DATA_UPDATE_ANALYSIS_SUCCESS,
  GET_DATA_UPDATE_ANALYSIS_FAILURE,
  GET_DOCUMENT_DETAILS_REQUEST,
  GET_DOCUMENT_DETAILS_SUCCESS,
  GET_DOCUMENT_DETAILS_FAILURE,
  RESET_BO_STATE
} from '../actions/types'

const initialState = {
  // Latest BO data
  latestBO: {
    data: [],
    loading: false,
    error: null,
    count: 0
  },
  
  // Individual BO data
  currentBO: {
    data: null,
    loading: false,
    error: null
  },
  
  // Search results
  searchResults: {
    data: [],
    loading: false,
    error: null,
    searchParams: null
  },
  
  // Data update analysis
  dataUpdateAnalysis: {
    data: null,
    loading: false,
    error: null
  },
  
  // Document details
  documentDetails: {
    data: null,
    loading: false,
    error: null
  }
}

const boReducer = (state = initialState, action) => {
  switch (action.type) {
    // Latest BO cases
    case FETCH_LATEST_BO_REQUEST:
      return {
        ...state,
        latestBO: {
          ...state.latestBO,
          loading: true,
          error: null
        }
      }
    
    case FETCH_LATEST_BO_SUCCESS:
      return {
        ...state,
        latestBO: {
          data: action.payload,
          loading: false,
          error: null,
          count: action.payload.length
        }
      }
    
    case FETCH_LATEST_BO_FAILURE:
      return {
        ...state,
        latestBO: {
          ...state.latestBO,
          loading: false,
          error: action.payload
        }
      }
    
    // Individual BO cases
    case FETCH_BO_BY_ID_REQUEST:
      return {
        ...state,
        currentBO: {
          ...state.currentBO,
          loading: true,
          error: null
        }
      }
    
    case FETCH_BO_BY_ID_SUCCESS:
      return {
        ...state,
        currentBO: {
          data: action.payload,
          loading: false,
          error: null
        }
      }
    
    case FETCH_BO_BY_ID_FAILURE:
      return {
        ...state,
        currentBO: {
          ...state.currentBO,
          loading: false,
          error: action.payload
        }
      }
    
    // Search BO cases
    case SEARCH_BO_REQUEST:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          loading: true,
          error: null
        }
      }
    
    case SEARCH_BO_SUCCESS:
      return {
        ...state,
        searchResults: {
          data: action.payload,
          loading: false,
          error: null,
          searchParams: action.payload.searchParams
        }
      }
    
    case SEARCH_BO_FAILURE:
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          loading: false,
          error: action.payload
        }
      }
    
    // Data update analysis cases
    case GET_DATA_UPDATE_ANALYSIS_REQUEST:
      return {
        ...state,
        dataUpdateAnalysis: {
          ...state.dataUpdateAnalysis,
          loading: true,
          error: null
        }
      }
    
    case GET_DATA_UPDATE_ANALYSIS_SUCCESS:
      return {
        ...state,
        dataUpdateAnalysis: {
          data: action.payload,
          loading: false,
          error: null
        }
      }
    
    case GET_DATA_UPDATE_ANALYSIS_FAILURE:
      return {
        ...state,
        dataUpdateAnalysis: {
          ...state.dataUpdateAnalysis,
          loading: false,
          error: action.payload
        }
      }
    
    // Document details cases
    case GET_DOCUMENT_DETAILS_REQUEST:
      return {
        ...state,
        documentDetails: {
          ...state.documentDetails,
          loading: true,
          error: null
        }
      }
    
    case GET_DOCUMENT_DETAILS_SUCCESS:
      return {
        ...state,
        documentDetails: {
          data: action.payload,
          loading: false,
          error: null
        }
      }
    
    case GET_DOCUMENT_DETAILS_FAILURE:
      return {
        ...state,
        documentDetails: {
          ...state.documentDetails,
          loading: false,
          error: action.payload
        }
      }
    
    // Reset state
    case RESET_BO_STATE:
      return initialState
    
    default:
      return state
  }
}

export default boReducer 